import OmronFooter from "components/OmronFooter";
import React from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import {
  selectEmail,
  selectCountry,
  selectFamilyName,
  selectFamilyNameFurigana,
  selectFirstName,
  selectFirstNameFurigana,
  selectCompany,
  selectCompanyFurigana,
  selectOffice,
  selectDdepartment,
  selectPosition,
  selectJobType,
  selectCompanyTel,
  selectPostalCode,
  selectState,
  selectCity,
  selectAddress,
  selectBuildingName,
  selectPassword,
  selectMarket_Status,
} from "features/signup";
import PageTitle from "components/PageTitle";
import OmronHeader from "components/OmronHeader";
import { useTranslation } from "react-i18next";
import { COUNTRY_JP } from "common/constants";
import { SignupConfJapan } from "./SignupConfJapan";
import { SignupConfOthers } from "./SignupConfOthers";
import LoadingPage from "components/LoadingPage";
import { RootState } from "app/store";

const SignupConfirm: React.FC = (): JSX.Element => {
  const { t } = useTranslation();
  const isSubmitting = useSelector(
    (state: RootState) => state.signup.submitting,
  );
  const email = useSelector(selectEmail);
  const password = useSelector(selectPassword);
  const country = useSelector(selectCountry);
  const familyName = useSelector(selectFamilyName);
  const familyNameFurigana = useSelector(selectFamilyNameFurigana);
  const firstName = useSelector(selectFirstName);
  const firstNameFurigana = useSelector(selectFirstNameFurigana);
  const company = useSelector(selectCompany);
  const companyFurigana = useSelector(selectCompanyFurigana);
  const office = useSelector(selectOffice);
  const department = useSelector(selectDdepartment);
  const position = useSelector(selectPosition);
  const jobType = useSelector(selectJobType);
  const companyTel = useSelector(selectCompanyTel);
  const postalCode = useSelector(selectPostalCode);
  const state = useSelector(selectState);
  const city = useSelector(selectCity);
  const address = useSelector(selectAddress);
  const buildingName = useSelector(selectBuildingName);
  const market_status = useSelector(selectMarket_Status);

  return (
    <>
    
    <Wrapper>
      <OmronHeader
        link={{ label: t("common.label.breadcrumbsSignin"), path: "/" }}
        label={[
          t("common.label.breadcrumbsSignup"),
          t("common.label.breadcrumbsSignupConf"),
        ]}
      />
      <PageMain>
      <LoadingPage hidden={!isSubmitting} />
        <InnerDiv>
          <PageTitle
            title={t("signupPage.label.confirmTitle")}
            text={t("signupPage.text.confirmDescription")}
          />
         
          {country === COUNTRY_JP ? (
            <SignupConfJapan
              email={email}
              password={password}
              country={country}
              familyName={familyName}
              firstName={firstName}
              familyNameFurigana={familyNameFurigana}
              firstNameFurigana={firstNameFurigana}
              company={company}
              companyFurigana={companyFurigana}
              office={office}
              department={department}
              position={position}
              jobType={jobType}
              companyTel={companyTel}
              postalCode={postalCode}
              state={state}
              city={city}
              address={address}
              buildingName={buildingName}
              market_status={market_status}
            />
          ) : (
            <SignupConfOthers
              email={email}
              password={password}
              country={country}
              familyName={familyName}
              firstName={firstName}
              company={company}
              office={office}
              department={department}
              position={position}
              jobType={jobType}
              companyTel={companyTel}
              postalCode={postalCode}
              state={state}
              city={city}
              address={address}
              buildingName={buildingName}
              market_status={market_status}
            />
          )}
        </InnerDiv>
      </PageMain>
      <OmronFooter />
    </Wrapper>
    </>
  );
};
export default SignupConfirm;

const PageMain = styled.main`
  grid-area: main;
  padding: 3.2rem 50px;
`;

const InnerDiv = styled.div`
  width: 1000px;
  margin: 0 auto;
`;

const Wrapper = styled.div`
  font-family: "源ノ角ゴシック Regular", "源ノ角ゴシック", "Noto Sans JP",
    "Roboto", Helvetica, "ヒラギノ角ゴ Pro W3", "Hiragino Kaku Gothic Pro",
    "メイリオ", "Meiryo", "Meiryo UI", sans-serif;
  color: #333333;
  font-size: 14px;
  line-height: 1.7;
  letter-spacing: 0;
  font-weight: normal;
`;
